import { Suspense, lazy, useEffect, useMemo, useRef, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CurrentContext from "./utils/CurrentContext";
import { FileDownload } from "./utils/jsHelper.js";
import { ToastContainer } from "react-toastify";

const Home = lazy(() => import("./pages/homePage"));
const AmmoCan = lazy(() => import("./pages/smartObject_AmmoCan.js"));
const Fridge = lazy(() => import("./pages/smartObject_Fridge.js"));
const Fatboy = lazy(() => import("./pages/smartObject_Fatboy.js"));
const Centurion = lazy(() => import("./pages/smartObject_Centurion.js"));
const ClassicPlus = lazy(() => import("./pages/smartObject_ClassicPlus.js"));
const ClassicSelect = lazy(() =>
  import("./pages/smartObject_ClassicSelect.js")
);
const Colonial = lazy(() => import("./pages/smartObject_Colonial.js"));
const ColonialNew = lazy(() => import("./pages/smartObject_ColonialNew.js"));
const Franklin = lazy(() => import("./pages/smartObject_Franklin.js"));
const Franklinn = lazy(() => import("./pages/smartObject_Franklinn.js"));
const Franklinnn = lazy(() => import("./pages/smartObject_Franklinnn.js"));
const Freedom = lazy(() => import("./pages/smartObject_Freedom.js"));
const HomeSafes = lazy(() => import("./pages/smartObject_HomeSafe.js"));
const HomeSafesSe = lazy(() => import("./pages/smartObject_HomeSafeSe.js"));
const Collector = lazy(() => import("./pages/smartObject_Collector.js"));
const Lincoln = lazy(() => import("./pages/smartObject_Lincoln"));
const NationalMagnum = lazy(() =>
  import("./pages/smartObject_NationalMagnum.js")
);
const PremiumHomeSafes = lazy(() =>
  import("./pages/smartObject_PremiumHomesafes.js")
);
const Presidential = lazy(() => import("./pages/smartObject_Presidential.js"));
const Tactical = lazy(() => import("./pages/smartObject_Tactical.js"));
const Usa = lazy(() => import("./pages/smartObject_USA.js"));
const VaultDoor = lazy(() => import("./pages/smartObject_Vaultdoor.js"));
const ArViewer = lazy(() => import("./components/ARViewer.js"));
const Loader = lazy(() => import("./components/Loader.js"));
const ARViewerWrapper = lazy(() => import("./components/ARViewerWrapper.js"));
const ModelInspector = lazy(() => import("./pages/modelInspector.js"));

// import { doorOpen } from "./utils/signals.js";
const stableSerialize = (value) => {
  if (value === null || value === undefined) return String(value);
  if (typeof value !== "object") return String(value);
  try {
    return JSON.stringify(value);
  } catch {
    return "";
  }
};

const shallowEqualObjects = (a, b) => {
  if (a === b) return true;
  if (!a || !b || typeof a !== "object" || typeof b !== "object") return false;
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;
  for (const key of aKeys) {
    if (a[key] !== b[key]) return false;
  }
  return true;
};

export default function App() {
  const [displayMeasureTool, setDisplayMeasureTool] = useState(false);
  const [autoRotate, setAutoRotate] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);
  const [doorOpen, setDoorOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [loading, setLoading] = useState(false);
  const [isARReady, setIsARReady] = useState(false);
  const [ARModelSrc, setARModelSrc] = useState(null);
  const [ARUnicode, setARUnicode] = useState(null);
  const [isAR, setIsAR] = useState(false);
  const [hingeType, SetHingeType] = useState({ Swing: "out", Hinge: "left" });
  const [orbitCamera, setOrbitCamera] = useState(true);

  const [isEditEnabled, setIsEditEnabled] = useState(false);

  const [lockVariant, setLockVariant] = useState("mechanicallock");
  const [colorVariant, setColorVariant] = useState({
    hardware: "blackchromehardware",
    outer: "bronzetextured",
    interior: "camelfabric",
    woodshelf: "pindotvelour",
    Swing: "out",
    Hinge: "left",
    doorPanel:false,
    threeSpoke:false,
  });
  
  const [iframeMessage, setIframeMessage] = useState("");
  const lastMessageKeyRef = useRef("");

  const setCurrentSafe = (value) => {
    setCurrent((prev) => (prev === value ? prev : value));
  };

  const setLockVariantSafe = (value) => {
    setLockVariant((prev) => (prev === value ? prev : value));
  };

  const setColorVariantSafe = (updater) => {
    setColorVariant((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      if (next === prev) return prev;
      if (next === null || prev === null) return next;
      return shallowEqualObjects(prev, next) ? prev : next;
    });
  };

  useEffect(() => {
    // Handler function for the message event
    const handleMessage = (event) => {
      const data = event?.data;
      if (!data || typeof data !== "object" || !data.type) return;
      const allowedTypes = new Set([
        "model",
        "interior",
        "color",
        "lock",
        "additional",
        "hingeside",
        "swing",
        "camera",
        "screenShot",
        "screenshot",
        "doorpanel",
        "handle",
      ]);
      if (!allowedTypes.has(data.type)) return;

      const key = stableSerialize(data);
      if (lastMessageKeyRef.current === key) return;
      lastMessageKeyRef.current = key;
      setIframeMessage(data);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  function handleTakeScreenshot() {
    const canvas = document.querySelector("canvas");
    if (canvas) {
      const url = canvas.toDataURL("image/jpeg");
      // console.log(url);
      // FileDownload(url, `${current}.jpg`);
      window.parent.postMessage({ type: "screenshotCaptured", url: url }, "*");
    } else {
      console.error("Canvas element not found!");
    }
  } 

  const customFunction = (iframeMessage) => {
    if (
      ["model", "color", "lock", "additional", "camera", "screenshot"].includes(
        iframeMessage?.type
      )
    ) {
      setARModelSrc((prev) => (prev === null ? prev : null));
      setARUnicode((prev) => (prev === null ? prev : null));
    }
    
    if (iframeMessage.type === "model") {
      if (iframeMessage.value) {
        setCurrentSafe(iframeMessage.value);
        if(iframeMessage.value === "centurion12" || iframeMessage.value === "centurion18" || iframeMessage.value === "centurion24" || iframeMessage.value === "centurion32") {
          //console.log("centurion model");
          setColorVariantSafe((prevState) => ({
            ...(prevState || {}),
            outer: 'texturedblack',
            interior: 'grayfabric',
            threeSpoke: false,
            doorPanel: false,
          }));
          setLockVariantSafe('securamtoplit');
        }
        if(!(iframeMessage.value === "vaultdoorbeast" || iframeMessage.value === "vaultdoorblockade" || iframeMessage.value === "centurion12" || iframeMessage.value === "centurion18" || iframeMessage.value === "centurion24" || iframeMessage.value === "centurion32")) {
          setColorVariantSafe(null);
          setLockVariantSafe(null);
        }else if(iframeMessage.value === "vaultdoorbeast"){
          setColorVariantSafe({
            hardware: "blackchromehardware",
            outer: "bronzegloss",
            interior: "none",
            Swing: "out",
            Hinge: "left",
          });
          setLockVariantSafe("mechanicallock")
        }else if(iframeMessage.value === "vaultdoorblockade"){
          setColorVariantSafe({
            hardware: "blackchromehardware",
            outer: "texturedblack",
            interior: "none",
            Swing: "out",
            Hinge: "left",
          });
          setLockVariantSafe("securamtoplit")
        }
      }
    } else if (iframeMessage.type === "interior") {
      if (iframeMessage.material) {
        setCurrentSafe(iframeMessage.material);
      }
    } else if (iframeMessage.type === "color") {
      if (iframeMessage.outer) {
        if(iframeMessage.outer === "texturedwhite" && iframeMessage.name === "Centurion24_color") {
          setColorVariantSafe((prevState) => ({
            ...(prevState || {}),
            outer: iframeMessage.outer,
            hardware: iframeMessage.hardware,
            interior: iframeMessage.interior,
            threeSpoke: true,
            doorPanel: false,
          }));
          setLockVariantSafe("securamtoplit");
        }else{
          setColorVariantSafe((prevState) => ({
            ...(prevState || {}),
            hardware: iframeMessage.hardware,
            outer: iframeMessage.outer,
            interior: iframeMessage.interior,
          }));
        }
      }
    } else if (iframeMessage.type === "lock") {
      if (iframeMessage.value) {
        if(iframeMessage.value === "dormakaba702d"){
          setLockVariantSafe("securambacklit");
        }else{
          setLockVariantSafe(iframeMessage.value);
        }
      }
    } else if (iframeMessage.type === "additional") {
      if (iframeMessage.woodshelf !== undefined) {
          setColorVariantSafe((prevState) => ({
          ...(prevState || {}),
          woodshelf: iframeMessage.woodshelf,
        }));
      }
      if (iframeMessage.swing !== undefined) {
        setColorVariantSafe((prevState) => ({
          ...(prevState || {}),
          Swing: iframeMessage.swing,
        }));
      }
      if (iframeMessage.hinge !== undefined) {
        setColorVariantSafe((prevState) => ({
          ...(prevState || {}),
          Hinge: iframeMessage.hinge,
        }));
      }
    }else if (iframeMessage.type === "hingeside") {
      if (iframeMessage.hinge !== undefined) {
        setColorVariantSafe((prevState) => ({
          ...(prevState || {}),
          Hinge: iframeMessage.hinge,
        }));
      }
    }else if (iframeMessage.type === "swing") {
      if (iframeMessage.swing !== undefined) {
        setColorVariantSafe((prevState) => ({
          ...(prevState || {}),
          Swing: iframeMessage.swing,
        }));
      }
    }else if (iframeMessage.type === "camera") {
      if (iframeMessage.value === "2d") {
        setOrbitCamera((prev) => (prev === false ? prev : false));
      }
      else {
        setOrbitCamera((prev) => (prev === true ? prev : true));
      }
    } else if (iframeMessage.type === "screenShot") {
      if (iframeMessage.value) {
        handleTakeScreenshot()
      }
    }else if (iframeMessage.type === "doorpanel") {
      if (iframeMessage.value) {
        setColorVariantSafe((prevState) => ({
          ...(prevState || {}),
          doorPanel: iframeMessage.doorPanel,
        }));
        setLockVariantSafe("securamtoplit");
      }
    }else if (iframeMessage.type === "handle") {
      if (iframeMessage.value) {
        setColorVariantSafe((prevState) => ({
          ...(prevState || {}),
          threeSpoke: iframeMessage.threeSpoke,
        }));
        setLockVariantSafe("securamtoplit");
      }
    }
  };

  useEffect(() => {
    if (!iframeMessage?.type) return;
    customFunction(iframeMessage);
  }, [iframeMessage]);

  const propObject = useMemo(() => ({
    current,
    setCurrent,
    colorVariant,
    setColorVariant,
    lockVariant,
    setLockVariant,
    isEditEnabled,
    setIsEditEnabled,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    doorOpen,
    displayMeasureTool,
    setDisplayMeasureTool,
    autoRotate,
    setAutoRotate,
    fullScreen,
    setFullScreen,
    doorOpen,
    setDoorOpen,
    orbitCamera,
    setOrbitCamera,
  }), [
    current,
    colorVariant,
    lockVariant,
    isEditEnabled,
    loading,
    isARReady,
    ARModelSrc,
    ARUnicode,
    isAR,
    doorOpen,
    displayMeasureTool,
    autoRotate,
    fullScreen,
    orbitCamera,
  ]);

  const routesMap = {
    "/": Home,
    "/ammocan": AmmoCan,
    "/fridge": Fridge,
    "/freedom": Freedom,
    "/usa": Usa,
    "/colonial": Colonial,
    "/colonialNew": ColonialNew,
    "/franklin": Franklin,
    "/franklinn": Franklinn,
    "/franklinnn": Franklinnn,
    "/lincoln": Lincoln,
    "/presidential": Presidential,
    "/classicselect": ClassicSelect,
    "/classicplus": ClassicPlus,
    "/magnum": NationalMagnum,
    "/fatboy": Fatboy,
    "/tactical": Tactical,
    "/homesafes": HomeSafes,
    "/homesafese": HomeSafesSe,
    "/collector": Collector,
    "/premium-homesafes": PremiumHomeSafes,
    "/vaultdoor": VaultDoor,
    "/centurion": Centurion,
    "/ar/preview/:token": ArViewer,
    "/inspector": ModelInspector,
  };

  const routes = Object.entries(routesMap).map(([path, Component]) => (
    <Route key={path} path={path} element={<Component />} />
  ));

  return (
    <Suspense fallback={<Loader loading={true} transparentBg={true} />}>
      <CurrentContext.Provider value={propObject}>
        <BrowserRouter>
          <Routes>
            {routes}
            <Route path="*" element={<h2>Page not Exist</h2>} />
          </Routes>
        </BrowserRouter>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          limit={5}
        />
        <Loader loading={loading} transparentBg={true} />
        <ARViewerWrapper />
      </CurrentContext.Provider>
    </Suspense>
  );
}
